module.exports = __webpack_public_path__ + "img/1538507886.a425ee15.jpg";